module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasActions) ? _c('span', {
    staticClass: "dashboard-kebab",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('md-dialog-confirm', {
    ref: "duplicateDialog",
    attrs: {
      "md-title": _vm.confirmDuplicateProject.title,
      "md-content-html": _vm.confirmContentDuplicate,
      "md-ok-text": _vm.confirmDuplicateProject.ok,
      "md-cancel-text": _vm.confirmDuplicateProject.cancel
    },
    on: {
      "close": _vm.duplicateProjectConfirm
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "duplicateLegacyDialog",
    attrs: {
      "md-title": _vm.confirmDuplicateProject.title,
      "md-content-html": _vm.confirmContentDuplicateLegacy,
      "md-ok-text": _vm.confirmDuplicateProject.ok,
      "md-cancel-text": _vm.confirmDuplicateProject.cancel
    },
    on: {
      "close": _vm.duplicateProjectConfirm
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "deleteDialog",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.confirmContentDelete,
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.deleteProjectConfirm
    }
  }), _vm._v(" "), _c('md-dialog', {
    ref: "renameDialog",
    staticClass: "kebab-rename-dialog",
    on: {
      "open": _vm.focusRename
    }
  }, [_c('md-dialog-title', [_vm._v("Rename project")]), _vm._v(" "), _c('md-dialog-content', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveRename.apply(null, arguments)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Project name")]), _vm._v(" "), _c('md-input', {
    ref: "renameInput",
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.preventDefault();
        return _vm.cancelRename.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.renameTitle),
      callback: function($$v) {
        _vm.renameTitle = $$v
      },
      expression: "renameTitle"
    }
  })], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.cancelRename
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    attrs: {
      "disabled": !_vm.renameChanged || _vm.renaming
    },
    on: {
      "click": _vm.saveRename
    }
  }, [_vm._v("Rename")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "moveDialog",
    staticClass: "kebab-move-dialog"
  }, [_c('md-dialog-title', [_vm._v("Move “" + _vm._s(_vm.project.title) + "” to the current editor?")]), _vm._v(" "), _c('md-dialog-content', [_c('p', [_vm._v("From now on this project opens in the current Cuelist editor. Nothing is copied and nothing is lost:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cues, notes, layers and structure stay as they are")]), _vm._v(" "), _c('li', [_vm._v("Your team keeps their access")]), _vm._v(" "), _c('li', [_vm._v("Version history and share links keep working")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("This move can’t be undone.")])])]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    attrs: {
      "disabled": _vm.moving
    },
    on: {
      "click": _vm.cancelMove
    }
  }, [_vm._v("Not now")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    attrs: {
      "disabled": _vm.moving
    },
    on: {
      "click": _vm.confirmMove
    }
  }, [_vm._v(_vm._s(_vm.moving ? 'Moving…' : 'Move project'))])], 1)], 1), _vm._v(" "), _c('button', {
    ref: "trigger",
    staticClass: "kebab-trigger",
    attrs: {
      "type": "button",
      "aria-haspopup": "true",
      "aria-expanded": _vm.open ? 'true' : 'false',
      "aria-label": "Project actions"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggle.apply(null, arguments)
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.openMenu.apply(null, arguments)
      }
    }
  }, [_c('md-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), (_vm.open) ? _c('ul', {
    ref: "menu",
    staticClass: "kebab-menu",
    style: (_vm.menuStyle),
    attrs: {
      "role": "menu"
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.preventDefault();
        return _vm.closeMenu.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.focusNext(1)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.focusNext(-1)
      }]
    }
  }, [(_vm.canMove) ? _c('li', {
    staticClass: "kebab-item",
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    },
    on: {
      "click": _vm.openMove
    }
  }, [_vm._v("Move to the current editor…")]) : _vm._e(), _vm._v(" "), (_vm.canRename) ? _c('li', {
    staticClass: "kebab-item",
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    },
    on: {
      "click": _vm.onRename
    }
  }, [_vm._v("Rename")]) : _vm._e(), _vm._v(" "), (_vm.canDuplicate) ? _c('li', {
    staticClass: "kebab-item",
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    },
    on: {
      "click": _vm.onDuplicate
    }
  }, [_vm._v("Duplicate")]) : _vm._e(), _vm._v(" "), (_vm.canDuplicate && _vm.canDelete) ? _c('li', {
    staticClass: "kebab-sep",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canDelete) ? _c('li', {
    staticClass: "kebab-item kebab-item-danger",
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("Delete")]) : _vm._e()]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c88387b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/kebab-menu.vue
// module id = 1212
// module chunks = 21